import { OrderExaminationStatus } from "Infrastructure/Api/Api";
import { z } from "zod";

export const getEditOrderExaminationFormSchema = () => {
	return z.object({
		partnerId: z.number().int().nullish(),
		examinationDate: z.string().nullish(),
		status: z.nativeEnum(OrderExaminationStatus).nullish(),
		result: z.string().nullish(),
	});
};

export type EditOrderExaminationFormModel = z.infer<
	ReturnType<typeof getEditOrderExaminationFormSchema>
>;
